export interface Feature {
  code: string;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export type FeaturesResponse = Feature[];

export interface AccountFeatureScopeResponse {
  data?: {
    scope?: string;
    uuid?: string;
    account_uuid?: string;
    features?: Array<string | { code?: string }>;
  };
}

export const FEATURE_CODES = {
  TRUSTED_DESTINATIONS: 'trusted-destinations',
  PENDING_LINKS: 'pending-links',
  E_LINKS: 'elink',
  IP_EXCLUSIONS: 'ip-exclusions',
  OBSERVE_POINT: 'observepoint',
  POWER_PAGES: 'power-pages',
  NO_BLANK_LINK_TEMPLATE: 'no-blank-link-template',
  INACTIVE_LINKS_CLEANUP: 'inactive-links-cleanup',
  GS1_LINK_TEMPLATES: 'gs1-link-templates',
  USE_REACT_UI: 'use-react-ui',
} as const;

export type FeatureCode = typeof FEATURE_CODES[keyof typeof FEATURE_CODES];

export function normalizeFeatureCodes(
  features: Array<string | { code?: string }> | null | undefined
): string[] {
  if (!Array.isArray(features)) {
    return [];
  }

  return features
    .map((feature) => {
      if (typeof feature === 'string') {
        return feature;
      }

      if (feature && typeof feature === 'object' && typeof feature.code === 'string') {
        return feature.code;
      }

      return null;
    })
    .filter((code): code is string => Boolean(code));
}

